<router-outlet (activate)="isLoaderVisible = false" />

@if (isLoaderVisible) {
  <div class="loader-container">
    <img loading="lazy" src="/assets/images/logos/cinetixx-logo.svg" alt="cinetixx" />
    <div class="loader">
      <div class="loader-bar"></div>
    </div>
  </div>
}

@if (isNewVersionModalVisible) {
  <cx-new-version-modal #newVersionModalComponent />
}
